export default __webpack_public_path__ + "static/media/bracket-ownership.33adca68.png";